var exports = {
  "k": "x7be19a29--c0be54--container",
};

module.exports = exports;
